export const Development = () => (
  <svg
    width="90"
    height="105"
    viewBox="0 0 90 105"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25 12.6547L44.919 1.15466L64.837 12.6547M25 12.6547L44.919 24.1547M25 12.6547V37.1547L44.919 48.6547M64.837 12.6547L44.919 24.1547M64.837 12.6547V37.1547L44.919 48.6547M44.919 24.1547V48.6547M44.919 48.6547V59.6547M44.919 59.6547V75.6547M44.919 59.6547H13V75.6547M44.919 59.6547H76.837V75.6547"
      stroke="#669E77"
      stroke-width="2"
    />
    <path
      d="M1 81.9337L13 75.1547L25 81.9337M1 81.9337L13 88.7127M1 81.9337V96.3757L13 103.155M25 81.9337L13 88.7127M25 81.9337V96.3757L13 103.155M13 88.7127V103.155"
      stroke="#669E77"
      stroke-width="2"
    />
    <path
      d="M33 81.9337L45 75.1547L57 81.9337M33 81.9337L45 88.7127M33 81.9337V96.3757L45 103.155M57 81.9337L45 88.7127M57 81.9337V96.3757L45 103.155M45 88.7127V103.155"
      stroke="#669E77"
      stroke-width="2"
    />
    <path
      d="M65 81.9337L77 75.1547L89 81.9337M65 81.9337L77 88.7127M65 81.9337V96.3757L77 103.155M89 81.9337L77 88.7127M89 81.9337V96.3757L77 103.155M77 88.7127V103.155"
      stroke="#669E77"
      stroke-width="2"
    />
  </svg>
);
